import { useSyncExternalStore } from 'react'

/** @type {'design-system' | 'layouts' | 'icon-library' | 'component-library' | 'canvas'} */
let activeDesignPreviewTab = 'design-system'

/** @type {Set<() => void>} */
const listeners = new Set()

export function getDesignPreviewTab() {
  return activeDesignPreviewTab
}

/** @param {string} tabId */
export function setDesignPreviewTab(tabId) {
  if (activeDesignPreviewTab === tabId) return
  activeDesignPreviewTab = tabId
  for (const listener of listeners) listener()
}

export function resetDesignPreviewTab() {
  setDesignPreviewTab('design-system')
}

/** @param {() => void} listener @returns {() => void} */
export function subscribeDesignPreviewTab(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** @returns {string} */
export function useDesignPreviewTab() {
  return useSyncExternalStore(subscribeDesignPreviewTab, getDesignPreviewTab)
}
